import styled from 'styled-components';
import PrimaryButton from '../PrimaryButton';

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 100;
`;

export const ModalCard = styled.div`
	background-color: #FFFFFF;
	border-radius: 16px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
	width: 100%;
	max-width: 560px;
	max-height: 90vh;
	overflow-y: auto;
`;

export const ModalHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 24px 24px 0;
`;

export const ModalTitle = styled.span`
	font-weight: 600;
	font-size: 18px;
	color: #26282A;
`;

export const ModalFooter = styled.div`
	border-top: 1px solid #E5E5E5;
`;

export const SaveButton = styled(PrimaryButton)`
	width: auto;
	height: 40px;
	padding: 0 24px;
	margin-top: 0 !important;
`;
